const plusMonthlyPrice = 7.99;
const plusYearlyPrice = 4.99;
const ambassadorMonthlyPrice = 19.99;
const ambassadorYearlyPrice = 14.99;

export const membershipsData = {
  Plus: {
    name: "Plus",
    features: [
      { title: "Unlimited Adventures", description: "Access to all premium adventure content and guides" },
      { title: "Offline Maps", description: "Download maps for offline use during your adventures" },
      { title: "Weather Alerts", description: "Real-time weather updates and safety notifications" },
      { title: "Priority Support", description: "24/7 customer support with faster response times" },
    ],
    dailyPrice: "0.26", // Daily price for PlusMonthly plan
    monthlyPrice: plusMonthlyPrice,
    yearlyPrice: plusYearlyPrice,
    savePercent: "35"
  },
  Ambassador: {
    name: "Ambassador",
    features: [
      { title: "Everything in Plus", description: "All Plus features included in your membership" },
      { title: "Exclusive Content", description: "Access to ambassador-only adventures and experiences" },
      { title: "Personal Adventure Coach", description: "One-on-one guidance from certified adventure experts" },
      { title: "Community Access", description: "Join our exclusive ambassador community and events" },
    ],
    dailyPrice: "0.66", // Daily price for AmbassadorMonthly plan
    monthlyPrice: ambassadorMonthlyPrice,
    yearlyPrice: ambassadorYearlyPrice,
    savePercent: "25"
  },
};

export const desktopMembershipsComparison = [
    {
      name: 'Free',
      chip: 'Free Forever',
      monthlyPrice: 0,
      yearlyPrice: 0,
      features: [
        { text: 'Handbook resources', icon: '✓' },
        { text: 'Attractions Map', icon: '✓' },
        { text: 'See Nearby Travellers', icon: '✓' },
        { text: 'Basic route tracking', icon: '✓' },
        { text: 'Family & Friends Sharing Portal', icon: '✓' },
        { text: 'Community access', icon: '✓' },
      ],
      buttonText: 'Download App',
      popular: false,
    },
    {
      name: 'Plus',
      chip: 'Most Popular',
      monthlyPrice: plusMonthlyPrice,
      yearlyPrice: plusYearlyPrice,
      features: [
        { text: 'Advanced route planning', icon: '✓' },
        { text: 'Offline attractions maps', icon: '✓' },
        { text: 'Uncover hidden Gems', icon: '✓' },
        { text: 'Emergency support', icon: '✓' },
        { text: 'Priority community access', icon: '✓' },
        { text: 'Premium support', icon: '✓' },
      ],
      buttonText: 'Upgrade',
      popular: true,
    },
    {
      name: 'Ambassador',
      chip: 'Pro Features',
      monthlyPrice: ambassadorMonthlyPrice,
      yearlyPrice: ambassadorYearlyPrice,
      features: [
        { text: 'Everything in Plus', icon: '✓' },
        { text: 'Custom route sharing', icon: '✓' },
        { text: 'Advanced analytics', icon: '✓' },
        { text: 'White-label options', icon: '✓' },
        { text: 'Dedicated support', icon: '✓' },
        { text: 'Early access to features', icon: '✓' },
      ],
      buttonText: 'Upgrade',
      popular: false,
    },
  ];

const membershipLabels = {
  Free: "Free - Limited Features",
  Plus: "Explorer Plus",
  Ambassador: "Ambassador",
};

export function getUserMembershipLabel(userMembership) {
  return membershipLabels[userMembership] || "Please Contact Support";
}